import request from "@services/request";

export const fetchAll = ({ loanNumber }) => request.get(`/a/applications/${loanNumber}/alerts`);

export const acknowledge = ({ loanNumber, uuid, message }) => {
  return request.put(
    `/a/applications/${loanNumber}/alerts/${uuid}/acknowledge`,
    { message },
  );
};
